import { useCallback } from 'react';
import axios, { AxiosResponse } from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import { serviceURLs } from './axios.constant';

interface IUseApiData {
  postData: <T>(
    url: string,
    baseService: string,
    data?: any
  ) => Promise<AxiosResponse<T>>;
}

const usePostApiData = (): IUseApiData => {
  const { getAccessTokenSilently } = useAuth0();

  const postData = useCallback(
    async <T,>(
      url: string,
      baseService: string,
      data?: any
    ): Promise<AxiosResponse<T>> => {
      const baseUrl = window.gbl_service_urls[serviceURLs[baseService]];
      const apiUrl = `${baseUrl}${url}`;
      const token = await getAccessTokenSilently();

      return axios.post<T>(apiUrl, data, {
        headers: {
          'Content-Type': 'application/json',
          'tenantid': '00000000-0000-0000-0000-000000000000',
          Authorization: `Bearer ${token}`
        }
      });
    },
    [getAccessTokenSilently]
  );

  return { postData };
};

export default usePostApiData;
